'use client'
import React from 'react'
import { motion } from 'framer-motion'
import { Calendar } from 'lucide-react'

const CTASection = () => {
	return (
		<section className="relative overflow-hidden bg-gradient-to-br from-[#3BCF8E] to-[#2DA771] py-24">
			<div className="pointer-events-none absolute inset-0 z-0">
				<div
					className="absolute inset-0 bg-repeat opacity-[0.085]"
					style={{
						backgroundImage:
							"url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 144 144'><g fill='none' stroke='%23ffffff' stroke-width='2.25' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(8 8)'><path d='M12 6v6l3.644 1.822'/><path d='M16 19h6'/><path d='M19 16v6'/><path d='M21.92 13.267a10 10 0 1 0-8.653 8.653'/></g><g transform='translate(56 8)'><path d='M16 14v2.2l1.6 1'/><path d='M16 2v4'/><path d='M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5'/><path d='M3 10h5'/><path d='M8 2v4'/><circle cx='16' cy='16' r='6'/></g><g transform='translate(104 8)'><path d='M8 2v4'/><path d='M16 2v4'/><rect width='18' height='18' x='3' y='4' rx='2'/><path d='M3 10h18'/></g><g transform='translate(8 56)'><path d='m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7'/><rect x='2' y='4' width='20' height='16' rx='2'/></g><g transform='translate(56 56)'><path d='M12.127 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.125'/><path d='M14.62 18.8A2.25 2.25 0 1 1 18 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z'/><path d='M16 2v4'/><path d='M3 10h18'/><path d='M8 2v4'/></g><g transform='translate(104 56)'><path d='M12 6v6l3.644 1.822'/><path d='M16 19h6'/><path d='M19 16v6'/><path d='M21.92 13.267a10 10 0 1 0-8.653 8.653'/></g><g transform='translate(8 104)'><path d='M16 14v2.2l1.6 1'/><path d='M16 2v4'/><path d='M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5'/><path d='M3 10h5'/><path d='M8 2v4'/><circle cx='16' cy='16' r='6'/></g><g transform='translate(56 104)'><path d='M8 2v4'/><path d='M16 2v4'/><rect width='18' height='18' x='3' y='4' rx='2'/><path d='M3 10h18'/></g><g transform='translate(104 104)'><path d='m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7'/><rect x='2' y='4' width='20' height='16' rx='2'/></g></g></svg>\")",
						backgroundSize: '120px 120px',
						transform: 'rotate(45deg) scale(2.5)',
						transformOrigin: 'center'
					}}
				/>
			</div>
			<div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
					viewport={{ once: true }}
					className="flex flex-col items-center"
				>
					{/* Icon */}
					<motion.div
						initial={{ scale: 0.8 }}
						whileInView={{ scale: 1 }}
						transition={{ type: "spring", stiffness: 150 }}
						className="p-4 rounded-2xl bg-white/20 backdrop-blur-sm border border-white/30 mb-8"
					>
						<Calendar className="h-12 w-12 text-white" />
					</motion.div>

					{/* Title */}
					<h2 className="text-2xl md:text-5xl font-bold text-white mb-6">
						Ready to Get Started?
					</h2>

					{/* Description */}
					<p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
						Book a personalized demo with our team to see how Infinitcode.ai can transform your code review process and boost your team&apos;s productivity.
					</p>

					{/* CTA Button */}
					<motion.a
						href="https://meet.brevo.com/gentian-elmazi/infinitcode-ai-meeting"
						target="_blank"
						rel="noopener noreferrer"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						className="inline-flex items-center bg-white text-[#3BCF8E] px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300"
					>
						<Calendar className="h-5 w-5 mr-2" />
						Schedule Demo
					</motion.a>
				</motion.div>
			</div>
		</section>
	)
}

export default CTASection
